import { forwardRef, Suspense, useEffect, useMemo, useState } from 'react';

import { useOneTimeMessagesDismissed } from '@trello/business-logic-react/member';
import { useTrelloCrossFlow } from '@trello/cross-flow';
import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { addIdleTask } from '@trello/idle-task-scheduler';
import { useLazyComponent } from '@trello/use-lazy-component';

const oneTimeMessage = '1p-ads-non-ppm-single-user-tool-survey';

export const LazyDiscoveryAdBoardCanvasPopper = forwardRef<HTMLElement>(
  (_, ref) => {
    const [showDiscoveryAdBoardCanvas, setShowDiscoveryAdBoardCanvas] =
      useState(false);
    const { getIsTargeted } = useTrelloCrossFlow('boardScreen');
    const { isOneTimeMessageDismissed } = useOneTimeMessagesDismissed();
    const isAdOneTimeMessageDismissed = useMemo(
      () => isOneTimeMessageDismissed(oneTimeMessage),
      [isOneTimeMessageDismissed],
    );

    const isTargetedForExperiment = useMemo(
      () => getIsTargeted(),
      [getIsTargeted],
    );

    useEffect(() => {
      if (isTargetedForExperiment && !isAdOneTimeMessageDismissed) {
        addIdleTask(() => setShowDiscoveryAdBoardCanvas(true), 1000);
      } else {
        setShowDiscoveryAdBoardCanvas(false);
      }
    }, [isAdOneTimeMessageDismissed, isTargetedForExperiment]);

    const DiscoveryAdBoardCanvasContainer = useLazyComponent(
      () =>
        import(
          /* webpackChunkName: "discovery-ad-board-canvas-container" */ './DiscoveryAdBoardCanvasContainer'
        ),
      { namedImport: 'DiscoveryAdBoardCanvasContainer' },
    );

    if (!showDiscoveryAdBoardCanvas) {
      return null;
    }

    return (
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <DiscoveryAdBoardCanvasContainer ref={ref} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    );
  },
);
